exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-link[data-v-1a6c22aa]{cursor:pointer}", ""]);

// exports
